"use strict";
/**
 * Session-related constants shared between web (idle reload) and backend (analytics cleanup).
 * Same 1h threshold: reload app after idle on home, and clean analytics sessions that never went past "session_started".
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOME_IDLE_RELOAD_MS = void 0;
/** Delay in ms before reloading the app when idle on home (1 hour). Also used as threshold for cleaning stale analytics sessions. */
exports.HOME_IDLE_RELOAD_MS = 60 * 60 * 1000;
